 
import {
  clearSmLogHistory,
  getSmLogHistoryFail,
  getSmLogHistoryStarted,
  getSmLogHistorySuccess
} from '../../../reducer/schedule-maintenance/SmLogHistoryReducer';
import { IData } from '../../../sagas/schedule-maintenance/SmLogHistorySaga';
import { getSmLogHistory } from '../../actionType/schedule-maintenance/SmLogHistoryTypes';
import {
  ClearGetSmLogHistory,
  GetSmLogHistoryFailure,
  GetSmLogHistoryFailurePayload,
  GetSmLogHistoryRequest,
  GetSmLogHistoryStarted,
  GetSmLogHistorySuccess,
  GetSmLogHistorySuccessPayload
} from '../../types/schedule-maintenance/SmLogHistoryTypes';

export const getSmLogHistoryRequest = (param_: IData): GetSmLogHistoryRequest => ({
  type: getSmLogHistory.FETCH_LOG_HISTORY,
  param: param_
});

/**
 * get metric summary started saga action
 * @returns get metric summary action
 */
export const getSmLogHistoryStart = (): GetSmLogHistoryStarted => ({
  type: getSmLogHistoryStarted.type
});

/**
 * Get metric summary success saga action
 * @param payload :Metric data
 * @returns success action
 */
export const getSmLogHistorySuccessful = (
  payload: GetSmLogHistorySuccessPayload
): GetSmLogHistorySuccess => ({
  type: getSmLogHistorySuccess.type,
  payload
});

/**
 * get metric Failed saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const getSmLogHistoryFailure = (
  payload: GetSmLogHistoryFailurePayload
): GetSmLogHistoryFailure => ({
  type: getSmLogHistoryFail.type,
  payload
});

/**
 * Clear metrics saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const cleargetSmLogHistory = (): ClearGetSmLogHistory => ({
  type: clearSmLogHistory.type
});
